import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { CONTACTS_EXPORT } from '../apis';

interface ConditionType {
  searchFilter?: string;
  key?: string;
  search?: string;
  operator?: number;
  flowId?: string;
  start?: string;
  end?: string;
  entryId?: string;
  entryType?: number;
}
interface PostContactsExportProps {
  filterCriteria: 1 | 2;
  limit: number;
  sortBy?: string;
  orderBy?: string;
  offset?: number;
  condition?: ConditionType[];
  contactsId?: string[];
}

interface ResponseType {
  code: number;
  msg: string;
  data: {
    fileUrl: string;
  };
}

async function postContactsExport({
  sortBy,
  orderBy,
  offset,
  limit,
  filterCriteria,
  condition,
  contactsId,
}: PostContactsExportProps): Promise<ResponseType> {
  return axios
    .post(CONTACTS_EXPORT, {
      limit,
      offset,
      ...(sortBy && { sortBy: sortBy }),
      ...(orderBy && { orderBy: orderBy }),
      ...(condition && condition.length > 0
        ? { condition, filterCriteria }
        : // 沒有條件則帶入 all
          { condition: [], filterCriteria: 1 }),
      ...(contactsId && contactsId.length && { contactsId: contactsId }),
    })
    .then((res) => res.data);
}

export function usePostContactsExport() {
  return useMutation({
    mutationKey: ['post-export-people-list'],
    mutationFn: async (params: PostContactsExportProps) => {
      // 不吞錯誤：後端失敗或回傳異常時要讓 mutation 進 onError，UI 才能提示使用者
      const data = await postContactsExport(params);
      if (data.code >= 40000 || !data.data?.fileUrl) {
        throw new Error(data.msg || 'export failed');
      }
      return data.data.fileUrl;
    },
  });
}

export default usePostContactsExport;
